import { getCompanyPictureUrl } from '../utils/cloudinary';

export const stringToCompanyModalImage = (picture: string): string => {
    // Returns optimized Cloudinary URL for company pictures
    // The picture parameter should match the image name in Cloudinary (without extension)
    if (!picture) return "";
    return getCompanyPictureUrl(picture);
};
